import { Component, OnInit } from '@angular/core';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { FormControl, Validators } from '@angular/forms';

import { Router } from '@angular/router';

@Component({
  selector: 'app-search-merchant',
  template: require('./onboarding-fleet.component.html'),
})
export class OnboardingFleetComponent implements OnInit {

  public merchantMobile: any;
  public overHeadPanelTitle = 'Fleet Onboarding';
  mobileFormControl = new FormControl('', [
    Validators.pattern('[0-9]{10}')
  ]);

  constructor(
    private router: Router,
    private hotkeysService: HotkeysService
  ) {
    this.hotkeysService.add(new Hotkey(['m', 'M'], (event: KeyboardEvent): boolean => {
      document.getElementById('search-mobile').click();
      return false;
    }));
  }

  ngOnInit() {
  }

  goBack() {
    this.router.navigate(['/modelSelection']);
  }

  onBoardFleet() {
      this.router.navigate(['/searchFleet']);
  }

  goToFleetOnboarding() {
    this.router.navigate(['/fleetOnboarding']);
  }

  goToFleetOnboardingStart() {
    this.router.navigate(['/fleetOnboardingStart']);
  }

  goToFleetManagerOnboarding() {
    this.router.navigate(['/fleetManagerOnboarding']);
  }

}
